import { render, staticRenderFns } from "./contactoForm.vue?vue&type=template&id=52e05d6d&scoped=true&"
import script from "./contactoForm.vue?vue&type=script&lang=js&"
export * from "./contactoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e05d6d",
  null
  
)

export default component.exports